"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetupMFA = void 0;
const SetupMFA_1 = __importDefault(require("./SetupMFA"));
exports.SetupMFA = SetupMFA_1.default;
